import React, { useState } from 'react';

import { ReactComponent as CaffeeInActive } from '../../../assets/icons/amenities/caffee-inactive.svg';
import { ReactComponent as CarwashInActive } from '../../../assets/icons/amenities/carwash-inactive.svg';
import { ReactComponent as GasStationInActive } from '../../../assets/icons/amenities/gas-station-inactive.svg';
import { ReactComponent as LockerInActive } from '../../../assets/icons/amenities/locker-inactive.svg';
import { ReactComponent as LoungeInActive } from '../../../assets/icons/amenities/lounge-inactive.svg';
import { ReactComponent as RelaxingInActive } from '../../../assets/icons/amenities/relaxing-inactive.svg';
import { ReactComponent as RestaurantInActive } from '../../../assets/icons/amenities/restaurant-inactive.svg';
import { ReactComponent as RestroomInActive } from '../../../assets/icons/amenities/restroom-inactive.svg';
import { ReactComponent as ShoppingInActive } from '../../../assets/icons/amenities/shopping-inactive.svg';
import { ReactComponent as WifiInActive } from '../../../assets/icons/amenities/wifi-inactive.svg';
import { ReactComponent as WorkshopInActive } from '../../../assets/icons/amenities/workshop-inactive.svg';
import { ReactComponent as RemoveIcon } from '../../../assets/icons/remove-icon.svg';
import { brandIcons } from '../../../config/branding';
import { Amenity } from '../../../interface/station-management.interface';
import MyButton from '../../../shared-components/button/Button';

interface SelectedAmenitiesProperties {
  selectedAmenities: Amenity[];
  handleCancel: () => void;
  handleStationDetailChange: (name: string, changeValue: Amenity[]) => void;
}

interface AmenitiesDetailsProperties {
  name: string;
  key: Amenity;
  svgIconActive: JSX.Element;
  svgIconInActive: JSX.Element;
}

/**
 * Selected amenities popup
 */
function SelectAmenities(properties: SelectedAmenitiesProperties) {
  const { selectedAmenities, handleCancel, handleStationDetailChange } = properties;

  const [newlySelectedAmenities, setNewlySelectedAmenities] =
    useState<Amenity[]>(selectedAmenities);

  const amenitiesDetails: AmenitiesDetailsProperties[] = [
    {
      name: 'Gas Station',
      key: 'Gas Station',
      svgIconActive: <brandIcons.GasStationActive />,
      svgIconInActive: <GasStationInActive />,
    },
    {
      name: 'Wifi',
      key: 'Free Wifi',
      svgIconActive: <brandIcons.WifiActive />,
      svgIconInActive: <WifiInActive />,
    },
    {
      name: 'Restroom',
      key: 'Restroom',
      svgIconActive: <brandIcons.RestroomActive />,
      svgIconInActive: <RestroomInActive />,
    },
    {
      name: 'Lounge',
      key: 'Lounge',
      svgIconActive: <brandIcons.LoungeActive />,
      svgIconInActive: <LoungeInActive />,
    },
    {
      name: 'Caffee',
      key: 'Cafe',
      svgIconActive: <brandIcons.CaffeeActive />,
      svgIconInActive: <CaffeeInActive />,
    },
    {
      name: 'Shopping',
      key: 'Shopping',
      svgIconActive: <brandIcons.ShoppingActive />,
      svgIconInActive: <ShoppingInActive />,
    },
    {
      name: 'Restaurant',
      key: 'Restaurant',
      svgIconActive: <brandIcons.RestaurantActive />,
      svgIconInActive: <RestaurantInActive />,
    },
    {
      name: 'Relaxing Area',
      key: 'Relaxing Area',
      svgIconActive: <brandIcons.RelaxingActive />,
      svgIconInActive: <RelaxingInActive />,
    },
    {
      name: 'Locker',
      key: 'Locker',
      svgIconActive: <brandIcons.LockerActive />,
      svgIconInActive: <LockerInActive />,
    },
    {
      name: 'Work Shop',
      key: 'Work Shop',
      svgIconActive: <brandIcons.WorkshopActive />,
      svgIconInActive: <WorkshopInActive />,
    },
    {
      name: 'Car Wash',
      key: 'Car Wash',
      svgIconActive: <brandIcons.CarwashActive />,
      svgIconInActive: <CarwashInActive />,
    },
  ];

  /**
   * Toggle amenities selection
   */
  const toggleAmenitiesSelection = (amenity: Amenity) => {
    setNewlySelectedAmenities((previousAmenities) => {
      if (previousAmenities?.includes(amenity)) {
        // Remove amenity from the array
        return previousAmenities.filter((each) => each !== amenity);
      }
      // Add amenity to the array
      return [...previousAmenities, amenity];
    });
  };

  /**
   * Send selected amenities
   */
  const handleSubmit = () => {
    handleStationDetailChange('amenities', newlySelectedAmenities);
    handleCancel();
  };

  return (
    <div className="select-amenities-wrap">
      <div className="select-amenities-container">
        {amenitiesDetails?.map((amenity) => (
          <div
            className="amenity-wrap"
            key={amenity.key}
            role="presentation"
            onClick={
              !newlySelectedAmenities?.includes(amenity.key)
                ? () => toggleAmenitiesSelection(amenity.key)
                : () => {}
            }>
            <div className="amenity-icon">
              <span
                className={`active-icon ${newlySelectedAmenities?.includes(amenity.key) ? 'view' : 'hide'}`}>
                {amenity.svgIconActive}
              </span>
              <span
                className={`inactive-icon ${!newlySelectedAmenities?.includes(amenity.key) ? 'view' : 'hide'}`}>
                {amenity.svgIconInActive}
              </span>
              {newlySelectedAmenities?.includes(amenity.key) && (
                <div
                  className="remove-icon"
                  role="presentation"
                  onClick={() => toggleAmenitiesSelection(amenity.key)}>
                  <RemoveIcon />
                </div>
              )}
            </div>
            <p>{amenity.name}</p>
          </div>
        ))}
      </div>
      <div className="select-amenities-button-wrap">
        <MyButton label="Cancel" buttonType="back" onClickFunc={handleCancel} />
        <MyButton label="Submit" buttonType="submit" onClickFunc={handleSubmit} />
      </div>
    </div>
  );
}

export default SelectAmenities;
